import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CheckboxGroup, withTooltips, Accordion } from '../../components/shared';
import { commifyNumber } from '../../utils/utilities';
import featureFlags from '../../utils/featureFlags'

export default class AdditionalCoverageSelector extends React.Component {
    constructor(props) {
        super(props)

        const { defaultAdditionalCoverageOptions, pricingValues, value, type, manuallySetPricing, isUnderwriter } = props
        this.state = {
            options: pricingValues ? additionalCoverageMapper(defaultAdditionalCoverageOptions, pricingValues, value, props.isPCOpsChecked,props.isESWorkChecked, props.submission.included, isUnderwriter, manuallySetPricing, this.props.submission.additionalInsuredArray) : defaultAdditionalCoverageOptions
        }
        props.updatePricingOptions(this.state.options)
        this.handleChangeOption = this.handleChangeOption.bind(this)
        this.onBlurTextboxHandler = this.onBlurTextboxHandler.bind(this)
        this.handleIncludedoption = this.handleIncludedoption.bind(this)
    }


    handleIncludedoption(selectedValues) {
        const { defaultAdditionalCoverageOptions, pricingValues, value, isPCOpsChecked,isESWorkChecked, isModified, isUnderwriter, manuallySetPricing } = this.props
        this.setState({
            options : additionalCoverageMapper(defaultAdditionalCoverageOptions, pricingValues, value, isPCOpsChecked,isESWorkChecked, selectedValues, isUnderwriter, manuallySetPricing, this.props.submission.additionalInsuredArray)
        })
        this.props.handleIncludedCoverageChange(selectedValues);
    }


    handleChangeOption(evt, selectedValues) {
        const { options } = this.state
        options.map((option) => {
            option.selected = selectedValues.includes(option.value)
            return option
        })
        this.setState({ options }, () => {
            this.props.updatePricingOptions(this.state.options)
        })
        this.props.onChange(evt, selectedValues)
    }

    onBlurTextboxHandler(priceValue) {
        this.props.onBlurHandler(priceValue)
    }

    render() {
        const { accordionArray, defaultAdditionalCoverageOptions, isModified, isUnderwriter, manuallySetPricing, value, pricingValues, isPCOpsChecked,isESWorkChecked, submission } = this.props
        const updatedOptions = pricingValues ? additionalCoverageMapper(defaultAdditionalCoverageOptions, pricingValues, value, isPCOpsChecked,isESWorkChecked, submission.included, isUnderwriter, manuallySetPricing, this.props.submission.additionalInsuredArray) : defaultAdditionalCoverageOptions;
        let selectedArray = Object.keys(value).filter(key => !!value[key].selected).sort();
        const AccordionCheckbox = Accordion(CheckboxGroup, accordionArray);
        return (
            <div className="additionalCoverageSelectorContainer">
                <h4 className='quoteTitle'>Additional Coverage</h4>
                {submission.type === 'oi' && <p className='pricing-help-text'>
                    Some risks qualify to have some of the additional coverages below included for no additional 
                    premium (Note: TRIA and HNOA will always have an associated AP). If you see an AP for a 
                    coverage you would like to add, other than TRIA or HNOA, please reach out to an underwriter 
                    to see if it can be included in the base pricing.
                </p>}
                {manuallySetPricing === true && submission.type === 'oi' && <div style={{textAlign:'right'}} className='pricing-column-title'>Included</div>}
                <AccordionCheckbox
                    name="additionalCoverage"
                    options={updatedOptions}
                    value={selectedArray}
                    onChange={this.handleChangeOption}
                    isModified={isModified}
                    manuallySetPricing={manuallySetPricing}
                    isUnderwriter={this.props.isUnderwriter}
                    onBlurTextboxHandler={this.onBlurTextboxHandler}
                    submission={this.props.submission}
                    isPCOpsChecked={this.props.isPCOpsChecked}
                    isESWorkChecked={this.props.isESWorkChecked}
                    handleIncludedoption={this.handleIncludedoption}
                />
            </div>
        )
    }
}

const additionalCoverageMapper = (
    options,
    extraOptions,
    selectedArray,
    isPCOpsChecked,
    isESWorkChecked,
    includedarray,
    isUnderwriter,
    manuallySetPricing,
    defaultBasePremium = ''
) => {
    const isPCChecked = isPCOpsChecked;
    const basePremium = extraOptions.hasOwnProperty('basePremium') ? extraOptions['basePremium'] : 0;
    return options.map(({ key, value, selected, disable, ...rest }) => {
        // subKey - helps align properties key names btw rating engines
        const subKey = Array.isArray(key) && key.find(k => extraOptions.hasOwnProperty(k)) || key;
        const price = extraOptions.hasOwnProperty(subKey) ? extraOptions[subKey] : defaultBasePremium;

        //it will do font bold
        const boldFlag = (disable || selectedArray.hasOwnProperty(value))
        let disableControl = disable;
        let textControl = typeof price === 'number' ? `+$${commifyNumber(price || '0')}` : ''
        if (value === 'identityRecovery') {
            disableControl = (basePremium > 24999) || disable
        }
        if (value === 'bankPremium' && manuallySetPricing === false) {
            disableControl = ((!rest.hideElement) || disable)
        }
        if (value === 'additionalInsureds' && manuallySetPricing === false) {
            disableControl = ((!rest.hideElement) || disable)
        }
        if(isUnderwriter === false && value === 'hnoaPremium') {
            disableControl = true;
        }
        if (value == 'extendedCompletedOps'){
            disableControl = isPCChecked;
        }
        if (isPCChecked === true && selectedArray.hasOwnProperty("extendedCompletedOps")){
            delete selectedArray.extendedCompletedOps;
        }
        if (!!includedarray) {
            if (includedarray.includes(value) == true && (manuallySetPricing == isUnderwriter)) {
                disableControl = includedarray.includes(value);
                textControl = `+$0`
            }
        }
        return {
            ...rest,
            disable: disableControl,
            value,
            text: textControl,
            boldFlag,
            selected: selectedArray.hasOwnProperty(value),
            key: subKey
        };
    });
};

AdditionalCoverageSelector.propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func
};
